import { useState, useEffect } from "react";

/* True below Tailwind's sm breakpoint — the width at which the landing sections
   swap their card grids for horizontal swipe rails.

   Mainly used to pass `still` to Reveal inside those rails: the entrance
   translate would overhang the scroller, and with overflow-x auto CSS computes a
   visible overflow-y to auto, which turns the rail into a vertical scroller. */
const QUERY = "(max-width: 639px)";

export default function useIsPhone() {
  const [phone, setPhone] = useState(
    () => typeof window !== "undefined" && !!window.matchMedia?.(QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia?.(QUERY);
    if (!mq) return;
    const onChange = (e) => setPhone(e.matches);
    setPhone(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return phone;
}
